import { Token } from "../domain/token";
import { TokenRepository } from "../domain/tokenRepository";

export async function getOrCreateToken(
  tokenRepository: TokenRepository
): Promise<Token> {
  return tokenRepository.getOrCreate();
}